module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-42.fcf6365b.png";